module.exports = [
  // 官方标签
  ...require('./tags'),
  // 官方内部变量
  ...require('./variables'),
  // 官方内建函数：字符串
  ...require('./stringFunctions'),
  // 官方内建函数：数字
  ...require('./numberFunctions'),
  // 官方内建函数：日期
  ...require('./dateFunctions'),
  // 官方内建函数：布尔
  ...require('./booleanFunctions'),
  // 官方内建函数：序列
  ...require('./seqFunctions'),
  // 官方内建函数：对象
  ...require('./objectFunctions'),
  // 官方内建函数：循环体内
  ...require('./inLoopFunctions'),
  // 系统扩展的内置变量
  ...require('./extVariables'),
  // 系统扩展的内置标签
  ...require('./extTags')
]
